import { BffResponse } from '../../types/bff-types';
import { fetchCallmeEmail } from './fetch/call-me-fetch';

export const sendCallMeForm = async (
	formData: FormData,
): Promise<{
	success: boolean;
	response: BffResponse | null;
}> => {
	const response = fetchCallmeEmail(formData);

	return response.then((res) => {
		return {
			success: Boolean(res && res.status.code === 200),
			response: res,
		};
	});
};
